import { Component, Output, EventEmitter, ViewChild, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ProfileQuicksearchComponent } from '../../../profiles/profile-quicksearch/profile-quicksearch.component';
import { ProfileMin } from '../../../profiles/shared/profile-min.model';
import { PagedResultGeneric } from '../..';

@Component({
  selector: 'wl-profile-search-and-select',
  templateUrl: './profile-search-and-select.component.html',
  styleUrls: ['./profile-search-and-select.component.less'],
  standalone: false
})
export class ProfileSearchAndSelectComponent implements AfterViewInit {
  @Input() initialKeyword: string;
  @Input() selectButtonText: string = 'common.select';
  @Output() profileSelected = new EventEmitter<ProfileMin>();

  @ViewChild(ProfileQuicksearchComponent) quickSearch: ProfileQuicksearchComponent;

  profileResults: PagedResultGeneric<ProfileMin>;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    if (this.quickSearch && this.initialKeyword) {
      this.quickSearch.Keyword = this.initialKeyword;
      this.quickSearch.search();

      this.cdr.detectChanges();
    }
  }

  setResults(profileResults: PagedResultGeneric<ProfileMin>): void {
    this.profileResults = profileResults;
  }

  clearResults(): void {
    this.profileResults = null;
    if (this.quickSearch) {
      this.quickSearch.Keyword = '';
    }
  }
}
